import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import LHCheckbox from '../../../../components/LHCheckBox';
import { AdminColors } from '../../../Admin/constants/adminColors';
import FontFamily from '../../../../constants/fonts';

interface ConfigCheckboxRowProps {
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

/** Labelled checkbox row used inside drawers (Choose Metrics, location focus area overrides). */
const ConfigCheckboxRow: React.FC<ConfigCheckboxRowProps> = ({ label, checked, disabled, onChange }) => (
  <TouchableOpacity
    style={[styles.row, disabled && styles.disabled]}
    activeOpacity={0.7}
    disabled={disabled}
    onPress={() => onChange(!checked)}
    accessibilityRole="checkbox"
    accessibilityState={{ checked, disabled: !!disabled }}
  >
    <View pointerEvents="none">
      <LHCheckbox value={checked} onValueChange={() => onChange(!checked)} />
    </View>
    <Text style={styles.label}>{label}</Text>
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', paddingVertical: 2 },
  disabled: { opacity: 0.5 },
  label: { fontSize: 14, color: AdminColors.textPrimary, fontFamily: FontFamily.regular },
});

export default ConfigCheckboxRow;
